/**
 * 화면에 쓰는 시각 표기.
 *
 * 서버가 주는 값은 전부 UTC ISO 문자열이다. 문자열을 잘라 쓰면 UTC가 그대로 보여서 "왜 9시간 전
 * 값이지"가 된다. 팀이 한국에 있으므로 브라우저 시간대가 아니라 **KST로 고정**해 보여 준다 —
 * 그래야 어디서 열어도 같은 값을 말한다.
 */
const KST = new Intl.DateTimeFormat('ko-KR', {
  timeZone: 'Asia/Seoul',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export class KstDateTime {
  /** `2026-09-05 10:43`. 값이 없거나 시각이 아니면 빈 문자열 — 부르는 쪽이 대체 문구를 정한다. */
  static format(iso: string | null | undefined): string {
    if (!iso) return '';
    const at = new Date(iso);
    if (Number.isNaN(at.getTime())) return '';
    const parts = Object.fromEntries(KST.formatToParts(at).map((part) => [part.type, part.value]));
    return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
  }
}
